module.exports = __webpack_public_path__ + "static/img/banner3.de34c7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner3.png
// module id = XMCP
// module chunks = 2